






























import { namespace } from 'vuex-class';
import Component from 'vue-class-component';

import CounterInfoCard from '@/components/counters/CounterInfoCard.vue';
import CounterData from '@/components/counters/CounterData.vue';
import { Counter } from '@/modules/backend/Entities/Counter';
import CounterLogs from '@/components/counters/CounterLogs.vue';
import { Mixins, Prop, Watch } from 'vue-property-decorator';
import Mixin from '@/mixins/base';

const CountersModule = namespace('dashboard/counters');

@Component({
  mixins: [Mixin],
  components: {
    'counter-info-card': CounterInfoCard,
    'counter-data-card': CounterData,
    'counter-logs': CounterLogs
  }
})
export default class SingleCounter extends Mixins(Mixin) {
  @CountersModule.Action('GetOne')
  private fetchCounterById!: (counterId: number) => Promise<void>;

  @CountersModule.Getter('CounterById')
  private getCounterById!: (counterId: number) => Counter | undefined;

  @Prop({ required: true })
  private readonly counterId!: number;

  private loading = false;

  private get counter(): Counter | undefined {
    return this.getCounterById(this.counterId);
  }

  private get hasCounter(): boolean {
    return this.counter instanceof Counter;
  }

  private async updateData(): Promise<void> {
    this.loading = true;
    await this.fetchCounterById(this.counterId);
    this.loading = false;
  }

  @Watch('counterId', { immediate: true })
  private async counterIdChangedHandler(): Promise<void> {
    await this.updateData();
  }
}
